import React from 'react';
import classnames from 'classnames';
import { useUserAuth } from 'contexts/UserAuth';
import { useRouter } from 'next/router';
import Link from 'next/link';

import MaxWidthContainer from 'components/MaxWidthContainer';
import { useGlobalConfig } from 'contexts/GlobalConfig';

const MobileTabBar = (props) => {
  const { ...restProps } = props;
  const router = useRouter();
  const { user } = useUserAuth();
  const { pathname, asPath } = router;

  // remove path query
  const currentPath = (asPath || '').split('?')[0];
  const { setShowMobileMoreModal } = useGlobalConfig();
  // console.log({ pathname, asPath });

  return (
    <div className="fixed bottom-0 left-0 z-20 flex h-[64px] w-full border-t border-gray-100 bg-white lg:hidden">
      <div
        className={classnames(
          'grid h-full w-full justify-between text-xs font-normal text-[#4A4A4A]',
          {
            'grid-cols-4': !user,
            'grid-cols-5': user,
          }
        )}
      >
        <Link
          prefetch={false}
          href="/"
          className="flex flex-col items-center justify-center gap-y-1"
        >
          <svg
            className={pathname === '/' ? 'text-sorra-pink' : ''}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M13.5977 2.75173C13.3727 2.52677 13.0675 2.40039 12.7493 2.40039C12.4311 2.40039 12.1259 2.52677 11.9009 2.75173L3.50092 11.1517C3.28233 11.3781 3.16137 11.6812 3.16411 11.9958C3.16684 12.3105 3.29304 12.6114 3.51553 12.8339C3.73802 13.0564 4.039 13.1826 4.35363 13.1853C4.66827 13.1881 4.97139 13.0671 5.19772 12.8485L5.54932 12.4969V20.4001C5.54932 20.7184 5.67575 21.0236 5.90079 21.2487C6.12583 21.4737 6.43106 21.6001 6.74932 21.6001H9.14932C9.46758 21.6001 9.7728 21.4737 9.99784 21.2487C10.2229 21.0236 10.3493 20.7184 10.3493 20.4001V18.0001C10.3493 17.6819 10.4757 17.3766 10.7008 17.1516C10.9258 16.9266 11.2311 16.8001 11.5493 16.8001H13.9493C14.2676 16.8001 14.5728 16.9266 14.7978 17.1516C15.0229 17.3766 15.1493 17.6819 15.1493 18.0001V20.4001C15.1493 20.7184 15.2757 21.0236 15.5008 21.2487C15.7258 21.4737 16.0311 21.6001 16.3493 21.6001H18.7493C19.0676 21.6001 19.3728 21.4737 19.5978 21.2487C19.8229 21.0236 19.9493 20.7184 19.9493 20.4001V12.4969L20.3009 12.8485C20.5272 13.0671 20.8304 13.1881 21.145 13.1853C21.4596 13.1826 21.7606 13.0564 21.9831 12.8339C22.2056 12.6114 22.3318 12.3105 22.3345 11.9958C22.3373 11.6812 22.2163 11.3781 21.9977 11.1517L13.5977 2.75173Z"
              fill="currentColor"
            />
          </svg>
          <p
            className={
              pathname === '/' ? 'font-medium text-[#111928]' : 'text-[#4A4A4A]'
            }
          >
            主頁
          </p>
        </Link>
        <Link
          prefetch={false}
          href="/campaign"
          className="flex flex-col items-center justify-center gap-y-1"
        >
          <svg
            className={pathname === '/campaign' ? 'text-sorra-pink' : ''}
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M5.875 3V7V3ZM3.875 5H7.875H3.875ZM6.875 17V21V17ZM4.875 19H8.875H4.875ZM13.875 3L16.161 9.857L21.875 12L16.161 14.143L13.875 21L11.589 14.143L5.875 12L11.589 9.857L13.875 3Z"
              fill="white"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p
            className={
              pathname === '/campaign'
                ? 'font-medium text-[#111928]'
                : 'text-[#4A4A4A]'
            }
          >
            試用活動
          </p>
        </Link>
        <Link
          prefetch={false}
          href="/rewards"
          className="flex flex-col items-center justify-center gap-y-1"
        >
          <svg
            className={pathname === '/rewards' ? 'text-sorra-pink' : ''}
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M12 6C12 5.60444 12.1173 5.21776 12.3371 4.88886C12.5568 4.55996 12.8692 4.30362 13.2346 4.15224C13.6001 4.00087 14.0022 3.96126 14.3902 4.03843C14.7781 4.1156 15.1345 4.30608 15.4142 4.58579C15.6939 4.86549 15.8844 5.22186 15.9616 5.60982C16.0387 5.99778 15.9991 6.39992 15.8478 6.76537C15.6964 7.13082 15.44 7.44318 15.1111 7.66294C14.7822 7.8827 14.3956 8 14 8H19C19.5304 8 20.0391 8.21071 20.4142 8.58579C20.7893 8.96086 21 9.46957 21 10C21 10.5304 20.7893 11.0391 20.4142 11.4142C20.0391 11.7893 19.5304 12 19 12V19C19 19.5304 18.7893 20.0391 18.4142 20.4142C18.0391 20.7893 17.5304 21 17 21H12H7C6.46957 21 5.96086 20.7893 5.58579 20.4142C5.21071 20.0391 5 19.5304 5 19V12C4.46957 12 3.96086 11.7893 3.58579 11.4142C3.21071 11.0391 3 10.5304 3 10C3 9.46957 3.21071 8.96086 3.58579 8.58579C3.96086 8.21071 4.46957 8 5 8H9.5C9.00555 8 8.5222 7.85338 8.11107 7.57867C7.69995 7.30397 7.37952 6.91352 7.1903 6.45671C7.00108 5.99989 6.95157 5.49723 7.04804 5.01228C7.1445 4.52732 7.3826 4.08187 7.73223 3.73223C8.08186 3.3826 8.52732 3.1445 9.01227 3.04804C9.49723 2.95157 9.99989 3.00108 10.4567 3.1903C10.9135 3.37952 11.304 3.69995 11.5787 4.11108C11.8534 4.5222 12 5.00555 12 5.5V6Z"
              fill="white"
            />
            <path
              d="M12 8V21M12 8V6C12 5.60444 12.1173 5.21776 12.3371 4.88886C12.5568 4.55996 12.8692 4.30362 13.2346 4.15224C13.6001 4.00087 14.0022 3.96126 14.3902 4.03843C14.7781 4.1156 15.1345 4.30608 15.4142 4.58579C15.6939 4.86549 15.8844 5.22186 15.9616 5.60982C16.0387 5.99778 15.9991 6.39992 15.8478 6.76537C15.6964 7.13082 15.44 7.44318 15.1111 7.66294C14.7822 7.8827 14.3956 8 14 8H12ZM12 8V5.5C12 5.00555 11.8534 4.5222 11.5787 4.11108C11.304 3.69995 10.9135 3.37952 10.4567 3.1903C9.99989 3.00108 9.49723 2.95157 9.01227 3.04804C8.52732 3.1445 8.08186 3.3826 7.73223 3.73223C7.3826 4.08187 7.1445 4.52732 7.04804 5.01228C6.95157 5.49723 7.00108 5.99989 7.1903 6.45671C7.37952 6.91352 7.69995 7.30397 8.11107 7.57867C8.5222 7.85338 9.00555 8 9.5 8H12ZM5 12H19M5 12C4.46957 12 3.96086 11.7893 3.58579 11.4142C3.21071 11.0391 3 10.5304 3 10C3 9.46957 3.21071 8.96086 3.58579 8.58579C3.96086 8.21072 4.46957 8 5 8H19C19.5304 8 20.0391 8.21072 20.4142 8.58579C20.7893 8.96086 21 9.46957 21 10C21 10.5304 20.7893 11.0391 20.4142 11.4142C20.0391 11.7893 19.5304 12 19 12M5 12V19C5 19.5304 5.21071 20.0391 5.58579 20.4142C5.96086 20.7893 6.46957 21 7 21H17C17.5304 21 18.0391 20.7893 18.4142 20.4142C18.7893 20.0391 19 19.5304 19 19V12"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p
            className={
              pathname === '/rewards'
                ? 'font-medium text-[#111928]'
                : 'text-[#4A4A4A]'
            }
          >
            兌換禮物
          </p>
        </Link>
        {user && (
          <Link
            prefetch={false}
            href={`/p/${user.referral_code}`}
            className="flex flex-col items-center justify-center gap-y-1"
          >
            <svg
              className={
                currentPath === `/p/${user.referral_code}`
                  ? 'text-sorra-pink'
                  : ''
              }
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="24"
              viewBox="0 0 25 24"
              fill="none"
            >
              <path
                d="M21.125 12C21.125 13.1819 20.8922 14.3522 20.4399 15.4442C20.0849 16.3013 19.6 17.097 19.0037 17.8038C18.8403 17.9974 18.6686 18.1843 18.489 18.364C17.6532 19.1997 16.6611 19.8626 15.5692 20.3149C14.4772 20.7672 13.3069 21 12.125 21C10.9431 21 9.77278 20.7672 8.68085 20.3149C7.58892 19.8626 6.59677 19.1997 5.76104 18.364C5.58136 18.1843 5.40967 17.9974 5.24635 17.8038C4.64999 17.097 4.16514 16.3013 3.81008 15.4442C3.35779 14.3522 3.125 13.1819 3.125 12C3.125 9.61305 4.07321 7.32387 5.76104 5.63604C7.44887 3.94821 9.73805 3 12.125 3C14.5119 3 16.8011 3.94821 18.489 5.63604C20.1768 7.32387 21.125 9.61305 21.125 12Z"
                fill="white"
              />
              <path
                d="M5.246 17.804C7.34442 16.6179 9.71458 15.9963 12.125 16C14.625 16 16.972 16.655 19.004 17.804M15.125 10C15.125 10.7956 14.8089 11.5587 14.2463 12.1213C13.6837 12.6839 12.9206 13 12.125 13C11.3294 13 10.5663 12.6839 10.0037 12.1213C9.44107 11.5587 9.125 10.7956 9.125 10C9.125 9.20435 9.44107 8.44129 10.0037 7.87868C10.5663 7.31607 11.3294 7 12.125 7C12.9206 7 13.6837 7.31607 14.2463 7.87868C14.8089 8.44129 15.125 9.20435 15.125 10ZM21.125 12C21.125 13.1819 20.8922 14.3522 20.4399 15.4442C19.9876 16.5361 19.3247 17.5282 18.489 18.364C17.6532 19.1997 16.6611 19.8626 15.5692 20.3149C14.4772 20.7672 13.3069 21 12.125 21C10.9431 21 9.77278 20.7672 8.68085 20.3149C7.58892 19.8626 6.59677 19.1997 5.76104 18.364C4.92531 17.5282 4.26238 16.5361 3.81008 15.4442C3.35779 14.3522 3.125 13.1819 3.125 12C3.125 9.61305 4.07321 7.32387 5.76104 5.63604C7.44887 3.94821 9.73805 3 12.125 3C14.5119 3 16.8011 3.94821 18.489 5.63604C20.1768 7.32387 21.125 9.61305 21.125 12Z"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
            <p
              className={
                currentPath === `/p/${user.referral_code}`
                  ? 'font-medium text-[#111928]'
                  : 'text-[#4A4A4A]'
              }
            >
              美妝檔案
            </p>
          </Link>
        )}
        <button
          href="/"
          className="flex flex-col items-center justify-center gap-y-1"
          onClick={() => {
            setShowMobileMoreModal(true);
          }}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="25"
            height="24"
            viewBox="0 0 25 24"
            fill="none"
          >
            <path
              d="M4.25 6H20.25H4.25ZM4.25 10H20.25H4.25ZM4.25 14H20.25H4.25ZM4.25 18H20.25H4.25Z"
              fill="white"
            />
            <path
              d="M4.25 18H20.25M4.25 6H20.25H4.25ZM4.25 10H20.25H4.25ZM4.25 14H20.25H4.25Z"
              stroke="#4A4A4A"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <p>更多</p>
        </button>
      </div>
    </div>
  );
};

export default MobileTabBar;
